var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 94,
    viewBox: "0 0 126 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.761 11.2543L142.77 11.2742L142.781 11.2933L163.349 47.4171L163.15 97.7677L0.707474 97.7677L18.5865 78.2987C22.9567 73.5399 28.7683 70.3474 35.1287 69.2116L37.3731 68.8108C47.4001 67.0203 55.8716 60.3425 59.9542 51.0108L65.8753 37.4768C69.1106 30.0819 75.2348 24.3356 82.8206 21.5771L99.7439 15.4232C102.441 14.4424 104.966 13.0411 107.225 11.2713L115.653 4.67C124.693 -2.41169 137.976 0.814577 142.761 11.2543Z",
    fill: "url(#paint0_linear_1342_530)",
    stroke: "#F0536F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1342_530",
    x1: -12.4902,
    y1: 155.061,
    x2: 132.45,
    y2: -98.3056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FFFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562995,
    stopColor: "#FAA8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#F65464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F65464"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/card1.fc4c871725710efb8c3a65a9d8038240.svg";
export { ForwardRef as ReactComponent };